import React from "react";

export const ErrorCircleFill: React.FC<any> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
      <g>
        <path
          d="M21,12C21,16.970599999999997,16.970599999999997,21,12,21C7.02944,21,3,16.970599999999997,3,12C3,7.02944,7.02944,3,12,3C16.970599999999997,3,21,7.02944,21,12ZM14.7803,10.28033C14.921,10.13968,15,9.94891,15,9.75C15,9.33579,14.6642,9,14.25,9C14.0511,9,13.8603,9.07902,13.7197,9.21967L12,10.93934L10.28033,9.21967C10.13968,9.07902,9.94891,9,9.75,9C9.33579,9,9,9.33579,9,9.75C9,9.94891,9.07902,10.13968,9.21967,10.28033L10.93934,12L9.21967,13.7197C9.07902,13.8603,9,14.0511,9,14.25C9,14.6642,9.33579,15,9.75,15C9.94891,15,10.13968,14.921,10.28033,14.7803L12,13.0607L13.7197,14.7803C13.8603,14.921,14.0511,15,14.25,15C14.6642,15,15,14.6642,15,14.25C15,14.0511,14.921,13.8603,14.7803,13.7197L13.0607,12L14.7803,10.28033Z"
          fill="currentColor"
          fillOpacity="1"
        />
      </g>
    </g>
  </svg>
);
